export type CommunicationTemplateType = 'email' | 'sms'
export enum EnumCommunicationTemplateType {
  email = 'email',
  sms = 'sms',
}
